module.exports = __webpack_public_path__ + "img/icons8-telegram-app-48.e735f215.svg";